<template>
  <div id="app">
    <div v-if="isLoggedIn">
      <Header :navigationPosition="navigationStore.navigationPosition" :userType="navigationStore.userType" />
    </div>

    <LoadingPopup :isLoading="loadingStore.isLoading" />
    <router-view/>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/common/HeaderView.vue';
import LoadingPopup from "@/components/common/LoadingPopup.vue";
import { useLoadingStore } from '@/stores/loadingStore';
import { useNavigationStore } from '@/stores/navigationStore';

const route = useRoute()
const loadingStore = useLoadingStore();
const navigationStore = useNavigationStore();

const isLoggedIn = ref(!!localStorage.getItem('user_id'))

watch(() => route.path, () => {
  isLoggedIn.value = !!localStorage.getItem('user_id')
})

</script>

<style>
#app {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>
